import { ref, watch, onBeforeMount, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'

export function usePageNavi () {
    
    const route = useRoute()

    const isOpenPageNavi = ref(false)

    function togglePageNavi() {
        isOpenPageNavi.value = !isOpenPageNavi.value
    }

    function resizeWindow (event) {
        if(event.target.innerWidth > 991 && isOpenPageNavi.value == true) {
            isOpenPageNavi.value = false
        }
    }

    onBeforeMount(() => {
        window.addEventListener('resize', resizeWindow)
    })

    onBeforeUnmount(() => {
        window.removeEventListener('resize', resizeWindow)
    })

    watch(() => route.path,
        () => {
            if (isOpenPageNavi.value) {
                isOpenPageNavi.value = false
            }
        }
    )

    watch(isOpenPageNavi, (newVal) => {
        const scrollWidth = document.body.offsetWidth - document.body.clientWidth

        const page = document.querySelector('.page')
        const top = document.querySelector('.uta-top')

        if(newVal == true) {
            if(document.body.scrollTop > 0)
                top.scrollIntoView({ block: "start", behavior: "smooth" })

            document.body.style.overflow = 'hidden'

            if(scrollWidth > 0) {
                document.body.style.paddingRight = scrollWidth + 'px'
                page.style.marginRight = -scrollWidth + 'px'
            }

            page.classList.add('page--translatex')
        } else {
            document.body.style = ''
            page.style.marginRight = '0'
            page.classList.remove('page--translatex')
        }
    })

    return {
        isOpenPageNavi,
        togglePageNavi
    }
}